import moment from "moment";

export default {
    data() {
        return {
            isScheduleBooking: false,
        }
    },

    methods: {
        /**
         * Validates a route for availability.
         * @param {Object} route - The route object to be validated.
         * @param {string} route.route_availability_days - The route available days to be validated.
         * @param {Date} route.route_availability_start_date - The route start date.
         * @param {Date} route.route_availability_end_date - The route end date.
         * @param {Date} tripData.selectedDate - The date to be validated against.
         * @param {string} tripData.tripType - The trip type one-way/return/subscription.
         * @param {number} tripData.numberOfWeeks - For subscription number of weeks.
         * @param {Array} tripData.selectedDays - The trip type one-way/return/subscription.
         * @param {function} callBack.available - Called if route is available and bookable.
         * @param {function} callBack.notAvailable - Called if route is available and bookable.
         * @param {function} callBack.availableInFuture - Called if route is available in future i.e start date > date.
         */
        validateRoute(route,tripData, callBack) {
            const selectedDay = this.dayOfWeekAsString(tripData.selectedDate.getDay());
            const routeAvailableDaysArray = route.route_availability_days ? JSON.parse(route.route_availability_days) : [];
            const isAvailableOnSelectDays = routeAvailableDaysArray.length ?
                this.isSubscriptionTrip(tripData.tripType) ? this.containsAllDates(routeAvailableDaysArray, tripData.selectedDays)
                    :routeAvailableDaysArray.includes(selectedDay.toLowerCase())
                : true;

            let willBeAvailableInFuture = false;
            let isCurrentlyAvailable = true;

            if(this.isSubscriptionTrip(tripData.tripType)) {
                const {startDate, endDate} =
                    this.getSubscriptionStartAndEndDates(tripData.selectedDate, tripData.selectedDays, tripData.numberOfWeeks)
                willBeAvailableInFuture = route.route_availability_start_date ?
                    this.getDateInMillis(route.route_availability_start_date) > this.getDateInMillis(startDate) : false;

                if(route.route_availability_start_date && route.route_availability_end_date) {
                    isCurrentlyAvailable =
                        this.isDateBetween(this.getDateInMillis(endDate),
                            this.getDateInMillis(route.route_availability_start_date),
                            this.getDateInMillis(route.route_availability_end_date))
                        &&
                        this.isDateBetween(this.getDateInMillis(endDate),
                            this.getDateInMillis(route.route_availability_start_date),
                            this.getDateInMillis(route.route_availability_end_date));
                } else if(route.route_availability_start_date) {
                    isCurrentlyAvailable = this.isGreaterOrEqual(this.getDateInMillis(startDate),
                        this.getDateInMillis(route.route_availability_start_date));
                } else if(route.route_availability_end_date) {
                    isCurrentlyAvailable = this.isLowerOrEqual(this.getDateInMillis(endDate),
                        this.getDateInMillis(route.route_availability_start_date));
                }
            } else {
                willBeAvailableInFuture = route.route_availability_start_date ?
                    this.getDateInMillis(route.route_availability_start_date) > this.getDateInMillis(tripData.selectedDate) : false;
                isCurrentlyAvailable = route.route_availability_end_date ?
                    this.getDateInMillis(tripData.selectedDate) >= this.getDateInMillis(route.route_availability_start_date) : true;
            }

            const isAvailable = isAvailableOnSelectDays && isCurrentlyAvailable && !willBeAvailableInFuture;
            // console.log({isAvailable, willBeAvailableInFuture, isCurrentlyAvailable, isAvailableOnSelectDays});
            if(isAvailable) {
                callBack.available.call(this, route);
            } else if(willBeAvailableInFuture) {
                callBack.availableInFuture.call(this, route);
            } else if(!isCurrentlyAvailable) {
                callBack.notAvailable.call(this, route, false);
            } else if(!isAvailableOnSelectDays) {
                callBack.notAvailable.call(this, route, true);
            }
        },
        getDateInMillis(date) {
            if(typeof date === "object") {
                return date.getTime();
            } else {
                return new Date(date).getTime();
            }
        },
        dayOfWeekAsString(dayIndex) {
            return ["sunday", "monday","tuesday","wednesday","thursday","friday","saturday"][dayIndex] || '';
        },
        getDateWiseDay(value) {
            return value > 1 ? value-1 : 0;
        },
        getSelectedDayIndex(day) {
            return{
                "sunday": 0,
                "monday": 1,
                "tuesday": 2,
                "wednesday": 3,
                "thursday": 4,
                "friday": 5,
                "saturday": 6
            }[day] || '';
        },
        getMomentAdditionalWeek(day, moment){
            const selectedDay = moment.isoWeekday();
            if(selectedDay <= day) {
                return 0;
            } else {
                return 1
            }
        },
        isSubscriptionTrip(tripType) {
          return tripType === 'subscription';
        },
        containsAllDates(source, days){
            let containsAll = true;
            days.forEach(day => {
                containsAll = containsAll && source.includes(this.dayOfWeekAsString(day - 1));
            })
            return containsAll;
        },
        isDateBetween(value, lowerLimit, upperLimit) {
            return this.isGreaterOrEqual(value, lowerLimit) && this.isLowerOrEqual(value, upperLimit);
        },
        isGreaterOrEqual(value, limit) {
            return value >= limit;
        },
        isLowerOrEqual(value, limit) {
            return value <= limit;
        },
        getSubscriptionStartAndEndDates(departureDate, selectedDays, numberOfWeeks) {

            const startDay = this.getDateWiseDay(selectedDays[0]);
            const endDay = this.getDateWiseDay(selectedDays[selectedDays.length - 1]);
            let departureStart = moment(new Date(departureDate));
            const extraWeeksToStartDate = this.getMomentAdditionalWeek(startDay, departureStart);
            departureStart = departureStart.add(extraWeeksToStartDate, 'weeks');

            let departureEnd = moment(new Date(departureDate));
            const extraWeeksToEndDate = this.getMomentAdditionalWeek(endDay, departureEnd) + numberOfWeeks > 1 ? numberOfWeeks : 0;
            departureEnd = departureEnd.add(extraWeeksToEndDate, 'weeks');

            let startDate = departureStart.day(startDay);
            let endDate = departureEnd.day(endDay);
            const res =  {
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD')
            };
            return res;
        },
    }
}